import {SerializeClass} from "models/SerializeClass";
import {Portfolio} from "models/global/Portfolio";

export class User extends SerializeClass {

	private _id: number = -1;
	private _token: string = "";
	private _domain: number = -1;
	private _firstName: string = "";
	private _lastName: string = "";
	private _fullName: string = "";
	private _userName: string = "";
	private _language: string = "";
	private _phone: string = "";
	private _totp: number = 0;
	private _securityLevel: number = 1;
	private _croppedProfilePicture: string = "";
	private _originalProfilePicture: string = "";
	private _portfolios: Portfolio[] = [];
	private _isHopaEmployee: boolean = false;

	get id(): number {
		return this._id;
	}

	set id(value: number) {
		this._id = value;
	}

	get token(): string {
		return this._token;
	}

	set token(value: string) {
		this._token = value;
	}

	get domain(): number {
		return this._domain;
	}

	set domain(value: number) {
		this._domain = value;
	}

	get firstName(): string {
		return this._firstName;
	}

	set firstName(value: string) {
		this._firstName = value;
	}

	get lastName(): string {
		return this._lastName;
	}

	set lastName(value: string) {
		this._lastName = value;
	}

	get fullName(): string {
		return this._fullName;
	}

	set fullName(value: string) {
		this._fullName = value;
	}

	get userName(): string {
		return this._userName;
	}

	set userName(value: string) {
		this._userName = value;
	}

	get language(): string {
		return this._language;
	}

	set language(value: string) {
		this._language = value;
	}

	get phone(): string {
		return this._phone;
	}

	set phone(value: string) {
		this._phone = value;
	}

	get totp(): number {
		return this._totp;
	}

	set totp(value: number) {
		this._totp = value;
	}

	get securityLevel(): number {
		return this._securityLevel;
	}

	set securityLevel(value: number) {
		this._securityLevel = value;
	}

	get croppedProfilePicture(): string {
		return this._croppedProfilePicture;
	}

	set croppedProfilePicture(value: string) {
		this._croppedProfilePicture = value;
	}

	get originalProfilePicture(): string {
		return this._originalProfilePicture;
	}

	set originalProfilePicture(value: string) {
		this._originalProfilePicture = value;
	}

	get portfolios(): Portfolio[] {
		return this._portfolios;
	}

	set portfolios(value: Portfolio[]) {
		this._portfolios = value;
	}

	get isHopaEmployee(): boolean {
		return this._isHopaEmployee;
	}

	set isHopaEmployee(value: boolean) {
		this._isHopaEmployee = value;
	}
}